<template>
  <div class="ibox">
    <a class="ibox-results-collapse visible-xs" role="button" data-toggle="collapse" href=".ibox-results-filters-collapse-box" aria-expanded="false" aria-controls="ibox-results-filters-collapse-box">
      Show Filters <i class="fa fa-bars"></i>
    </a>
    <div class="ibox-results-filters-collapse-box collapse in">
      <div class="ibox-results-filters">
        <div class="row">
          <div class="col-sm-6 col-lg-3">
            <div class="form-group">
              <label class="control-label">Keywords</label>
              <input type="text" class="form-control" v-model="keywords">
            </div>
          </div>
          <div class="col-sm-6 col-lg-2">
            <div class="form-group">
              <label class="control-label">Commodity</label>
              <selectize
                :options="commodityOptionsWithAll"
                name="commodity"
                v-model="commodity">
              </selectize>
            </div>
          </div>
          <div class="col-sm-6 col-lg-offset-4 col-lg-3">
            <div class="form-group">
              <label class="control-label">Date Range</label>
              <date-range v-model="dateRange" name="date_range"></date-range>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ibox-content">
      <ul class="list-detail list-detail-load-request">
        <load-request-item
          v-for="load in loads"
          :key="load.id"
          :load="load">
        </load-request-item>
      </ul>

      <div class="text-center text-muted" v-show="haveNoLoads">
        <strong>There are no load requests.</strong>
      </div>
    </div>

    <lazy-loading v-show="haveLoads" :reached-bottom="getLoadsForNextPage" :filters="filters" ref="lazyLoading">
      <strong slot="finished" class="text-muted">There are no more load requests.</strong>
    </lazy-loading>

    <load-request-modal></load-request-modal>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
  import { ADD_LOAD } from 'vx/mutations'
  import { Selectize, DateRange } from 'components/forms'
  import { LazyLoading } from 'components/misc'
  import { isEqual } from 'lodash'
  import LoadRequestModal from './LoadRequestModal'
  import LoadRequestItem from './LoadRequestItem'
  import $ from 'jquery'

  export default {
    components: {
      Selectize,
      DateRange,
      LazyLoading,
      LoadRequestModal,
      LoadRequestItem
    },

    data () {
      return {
        commodity: null,
        keywords: null,
        dateRange: {
          from: null,
          to: null
        }
      }
    },

    watch: {
      /**
       * Watch filters for deep changes, refetch loads if they change.
       */
      filters: {
        handler (newFilters, oldFilters) {
          if (isEqual(newFilters, oldFilters)) {
            return
          }

          this.getLoadRequests()
        },
        deep: true
      }
    },

    computed: {
      ...mapGetters('commodity', ['commodityOptionsWithAll']),
      ...mapState('load', ['load', 'loads']),
      ...mapGetters('load', ['haveLoads', 'haveNoLoads']),

      filters () {
        return {
          requests: true,
          commodity: this.commodity,
          keywords: this.keywords,
          from: this.dateRange.from,
          to: this.dateRange.to
        }
      }
    },

    created () {
      this.getLoadRequests()
      this.getCommodities()

      if (this.$route.name === 'loads.requests.view') {
        this.getLoadToView()
      }
    },

    methods: {
      ...mapActions('load', ['getLoads', 'getLoadsForNextPage', 'getLoad']),
      ...mapMutations('load', [ADD_LOAD]),
      ...mapActions('commodity', ['getCommodities']),

      /**
       * Reset the lazy loading component.
       *
       * @return void
       */
      resetLazyLoading () {
        this.$refs.lazyLoading.$emit('reset')
      },

      /**
       * Get the load requests for this carrier.
       *
       * @return Promise
       */
      getLoadRequests () {
        return this.getLoads(this.filters).then(this.resetLazyLoading).catch(this.failedToLoadJobs)
      },

      /**
       * Get and show the load request modal for an existing load request.
       *
       * @return Promise
       */
      getLoadToView () {
        const addLoadToLoads = () => {
          // We need to check that this is actually a load request. If it's not we'll reject here
          // so that we get kicked back to the main load requests route.
          if (this.load.request_sent === false) {
            return Promise.reject()
          }

          this[ADD_LOAD](this.load)
        }

        const showLoadRequestModalIfView = () => {
          // Only show the modal if we are viewing the request and not performing an action.
          if (this.$route.name === 'loads.requests.view' && !this.$route.params.action) {
            setTimeout(() => ($('.modal-load-request').modal('show')), 500)
          }
        }

        const redirectToRequests = () => {
          this.$router.push({ name: 'loads.requests' })
        }

        return this.getLoad(this.$route.params.id).then(addLoadToLoads).then(showLoadRequestModalIfView).catch(redirectToRequests)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Requests.vue?6c41743d